import React from "react";
import { useParams } from "react-router-dom";

import { Badge2 } from "@/ui2/atoms/Badge";
import type { PatientDetails, UUID } from "@/core/types";

import { PatientStatusMenu } from "./PatientStatusMenu";

type PatientStatusProps = {
  patientDetails: PatientDetails;
};

export function PatientStatus({ patientDetails }: PatientStatusProps) {
  const { first_name, inactivation_type, is_wait_listed, last_name, previous_status, status } =
    patientDetails;
  const { patientId: patientIdParam } = useParams<{ patientId: string }>();
  const patientId = patientIdParam as UUID;

  const patientName = `${first_name} ${last_name}`;
  const isInactive = status === "INACTIVE";

  return (
    <div className="tw:flex tw:gap-2">
      <Badge2 size="md" variant={isInactive ? "error" : "success"}>
        {status}
      </Badge2>

      {is_wait_listed && (
        <Badge2 size="md" variant="warning">
          Waitlisted
        </Badge2>
      )}

      {inactivation_type !== "ACCESS_REVOKED" && (
        <PatientStatusMenu
          is_wait_listed={is_wait_listed}
          isInactive={isInactive}
          patientId={patientId}
          patientName={patientName}
          previous_status={previous_status}
        />
      )}
    </div>
  );
}
